var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"UHW8glWmFQjB8dbIBZgZn"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["core@lifepal-mw"]={id:"UHW8glWmFQjB8dbIBZgZn"};
      